const Utils = {
    isMobile: () => {
        return false;
    },
};
export default Utils;
